import { render, staticRenderFns } from "./policyKnow.vue?vue&type=template&id=eca774b6&scoped=true&"
import script from "./policyKnow.vue?vue&type=script&lang=js&"
export * from "./policyKnow.vue?vue&type=script&lang=js&"
import style0 from "./policyKnow.vue?vue&type=style&index=0&id=eca774b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca774b6",
  null
  
)

export default component.exports